module.exports = __webpack_public_path__ + "static/img/banner@2x.455acfd.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/home/banner@2x.png
// module id = OxYQ
// module chunks = 8